"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaMenu = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var MediaItem_1 = require("./MediaItem");
var Icon_1 = require("../Icon");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var MediaContext_1 = require("./MediaContext");
var MediaMenu = function (_a) {
    var mediaItem = _a.mediaItem, onDelete = _a.onDelete, props = __rest(_a, ["mediaItem", "onDelete"]);
    var mediaContext = (0, MediaContext_1.useMediaContext)();
    var _js = mediaContext._js;
    var expandIcon = React.createElement(Icon_1.Icon, { color: "blueGray.600", size: "lg", type: pro_solid_svg_icons_1.faExpand });
    var gearIcon = React.createElement(Icon_1.Icon, { color: "blueGray.600", size: "lg", type: pro_solid_svg_icons_1.faGear });
    var trashIcon = React.createElement(Icon_1.Icon, { color: "blueGray.600", size: "lg", type: pro_solid_svg_icons_1.faTrash });
    var cropIcon = React.createElement(Icon_1.Icon, { color: "blueGray.600", size: "lg", type: pro_solid_svg_icons_1.faCrop });
    var cropMarker = React.createElement(Icon_1.Icon, { color: "blueGray.600", size: "lg", type: pro_solid_svg_icons_1.faMarker });
    var copyIcon = React.createElement(Icon_1.Icon, { color: "blueGray.600", size: "lg", type: pro_solid_svg_icons_1.faCopy });
    var fullSizeMenuItem = null;
    var fullSizeURL = null;
    var additionalImageItems = null;
    var copyMenuItem = null;
    if ((0, MediaItem_1.isGuideImage)(mediaItem)) {
        fullSizeURL = mediaItem.original;
        fullSizeMenuItem = (React.createElement(react_1.MenuItem, { icon: expandIcon, as: "a", href: fullSizeURL, target: "_blank", "data-feature-id": "media_manager_item_menu_full_size" }, _js('Full Size')));
        var markerMenuItem = null;
        if (mediaContext.markersEnabled) {
            markerMenuItem = (React.createElement(react_1.MenuItem, { icon: cropMarker, onClick: function () { return mediaContext.markupGuideImage(mediaItem); }, "data-feature-id": "media_manager_item_menu_markers" }, _js('Markers')));
        }
        var cropMenuItem = null;
        if (mediaContext.cropEnabled) {
            cropMenuItem = (React.createElement(react_1.MenuItem, { icon: cropIcon, onClick: function () { return mediaContext.cropGuideImage(mediaItem); }, "data-feature-id": "media_manager_item_menu_crop" }, _js('Crop')));
        }
        additionalImageItems = (React.createElement(React.Fragment, null,
            markerMenuItem,
            cropMenuItem));
    }
    if (!(0, MediaItem_1.isUploadingMediaItem)(mediaItem) && !(0, MediaItem_1.isDocument)(mediaItem)) {
        copyMenuItem = (React.createElement(react_1.MenuItem, { icon: copyIcon, onClick: function () { return mediaContext.copyMediaItem(mediaItem); }, "data-feature-id": "media_manager_item_menu_copy" }, _js('Copy')));
    }
    // By default, "Delete" removes the media item from a user's media library.
    //  but this behavior can be overridden by the parent context.
    //  EG, in the MediaInput, it unlinks the media item from the current context, but leaves the item in the media library.
    var handleDelete = onDelete || (function () { return mediaContext.deleteMediaItem(mediaItem); });
    return (React.createElement(react_1.Menu, { placement: "top" },
        React.createElement(react_1.MenuButton, __assign({ fontSize: "10px", mt: 1, as: react_1.Button, size: "tn", p: 1, pl: 2, rightIcon: gearIcon, "data-feature-id": "media_manager_item_open_menu" }, props), _js('EDIT')),
        React.createElement(react_1.MenuList, { fontSize: "12px", minW: "110px" },
            fullSizeMenuItem,
            React.createElement(react_1.MenuItem, { icon: trashIcon, onClick: function () { return handleDelete(mediaItem); }, "data-feature-id": "media_manager_item_menu_delete" }, _js('Delete')),
            additionalImageItems,
            copyMenuItem)));
};
exports.MediaMenu = MediaMenu;
